import axios from 'axios';

axios.defaults.timeout = 20000;
axios.defaults.withCredentials = true;
//http request 拦截器
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type':'application/json; charset=UTF-8'
    }
    const token = localStorage.getItem("access-token");
    if (token) {
        config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);


//http response 拦截器
axios.interceptors.response.use(
  response => {
    if(response.data.errCode == 401){
      router.push({
        path:"/login",
      })
    }
    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url, data)
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}

// if (_.indexOf(noTokenList, url) == -1) {
//   if (url === refreshTokenUrl) {
//     const RefreshToken = localStorage.getItem("refresh-token");
//     config.headers["refreshToken"] = RefreshToken;
//   } else {
//     const token = localStorage.getItem("access-token");
//     if (token) {
//       config.headers["Authorization"] = token;
//     }
//   }
// }


// WEBPACK FOOTER //
// ./src/utils/http.js